<!--  <accordion-group [isOpen]="isAllOpen" heading="Electricity" class="accordion-item mb-3 panel-open" #group>
            <span accordion-heading class="float-end fs-5 d-flex align-items-center">
                <i class="mdi font-size-24"
                    [ngClass]="!group?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ' : 'mdi mdi-chevron-up accor-plus-icon '"></i>
            </span>
            <form [formGroup]="utilitiesForm">


                <div *ngFor="let range of squareFeetRangesArray.controls; let i = index" [formGroupName]="i"
                    class="range-block mb-4">

                    <div class="row mb-2">
                        <div class="col-4">
                            <div class="mb-3">
                                <label>Square Feet Minimum value <span class="required">*</span></label>
                                <input formControlName="squareFeetMin" class="form-control">
                            </div>
                        </div>

                        <div class="col-4">
                            <div class="mb-3">
                                <label>Square Feet Maximum value <span class="required">*</span></label>
                                <input formControlName="squareFeetMax" class="form-control">
                            </div>
                        </div>

                        <div class="col-4 d-flex align-items-start justify-content-end">
                            <button type="button" class="btn btn-danger px-3 py-2 mt-4" (click)="addSquareFeetRange()">
                                Add New Sqft Range
                            </button>
                        </div>

                    </div>


                  
                    <div formArrayName="electricity">
                        <div *ngFor="let group of electricityArray(i).controls; let j = index" [formGroupName]="j"
                            class="row row-cols-lg-4">

                            <div class="col">
                                <div class="mb-3">
                                    <label> Supplier Name<span class="required">*</span></label>
                                    <ng-select [items]="electricityTypeItems" bindLabel="name" bindValue="id"
                                        placeholder="Select..." formControlName="slabName"></ng-select>

                                    @if((submitted || group.get('slabName')?.touched)&& group.get('slabName')?.errors) {
                                    <div class="invalid-feedback">
                                        @if(group.get('slabName')?.errors?.['required']) {
                                        <div>{{ utility_electricity_Validations.slabName.required }}</div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>


                            <div class="col">
                                <div class="mb-3">
                                    <label>Min (kWh)<span class="required">*</span></label>
                                    <input type="text" class="form-control" formControlName="minKwh">

                                    @if((submitted || group.get('minKwh')?.touched)&& group.get('minKwh')?.errors) {
                                    <div class="invalid-feedback">
                                        @if(group.get('minKwh')?.errors?.['required']) {
                                        <div>{{ utility_electricity_Validations.minKwh.required }}</div>
                                        }
                                        @if(group.get('minKwh')?.errors?.['pattern']) {
                                        <div>{{utility_electricity_Validations.minKwh.patternValidation}}</div>
                                        }
                                        @if(group.get('minKwh')?.errors?.['slabOverlap']) {
                                        <div>Min must be greater than Max value of another slab.</div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>

                            <div class="col">
                                <div class="mb-3">
                                    <label>Max (kWh)<span class="required">*</span></label>
                                    <input type="text" class="form-control" formControlName="maxKwh"
                                        (input)="oneleInput($event)">

                                    @if((submitted || group.get('maxKwh')?.touched)&& group.get('maxKwh')?.errors) {
                                    <div class="invalid-feedback">
                                        @if(group.get('maxKwh')?.errors?.['required']) {
                                        <div>{{ utility_electricity_Validations.maxKwh.required }}</div>
                                        }
                                        @if(group.get('maxKwh')?.errors?.['pattern']) {
                                        <div>{{utility_electricity_Validations.maxKwh.patternValidation}}</div>
                                        }
                                        @if(group.get('maxKwh')?.errors?.['maxLessThanMin']) {
                                        <div>Min must be less than Max.</div>
                                        }
                                    </div>
                                    }
                                </div>
                            </div>

                            <div class="col">
                                <div class="mb-3 d-flex align-items-center justify-content-between">
                                    <div class="w-100">
                                        <label>Slab Per Unit Price <span class="required">*</span></label>
                                        <input type="text" class="form-control" formControlName="unitPrice"
                                            (input)="oneleInput($event)">

                                        @if((submitted || group.get('unitPrice')?.touched)&&
                                        group.get('unitPrice')?.errors) {
                                        <div class="invalid-feedback">
                                            @if(group.get('unitPrice')?.errors?.['required']) {
                                            <div>{{ utility_electricity_Validations.UnitPrice.required }}</div>
                                            }
                                            @if(group.get('unitPrice')?.errors?.['maxValue']) {
                                            <div>{{ utility_electricity_Validations.UnitPrice.maxValue }}</div>
                                            }
                                            @if(group.get('unitPrice')?.errors?.['pattern']) {
                                            <div>{{utility_electricity_Validations.UnitPrice.patternValidation}}</div>
                                            }
                                        </div>
                                        }
                                    </div>

                                   
                                    <button type="button" *ngIf="electricityArray(i).controls.length > 1"
                                        class="btn btn-danger ms-2 mt-4 px-1 py-1" (click)="removeElectricity(i, j)">
                                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>

                   
                    <div class="d-flex justify-content-end mb-3">
                        <button type="button" class="btn btn-primary" (click)="addElectricity(i)"> Add Row</button>
                    </div>
                   
                    <hr>
                </div>

            </form>
        </accordion-group>
 -->
<form [formGroup]="utilitiesForm">
    <accordion [closeOthers]="true" class="accordion custom-accordion" [isAnimated]="true">

        <!-- GAs -->
        <!-- Gas Section -->
        <accordion-group [isOpen]="isAllOpen" heading="Gas" class="accordion-item mb-3 panel-open" #group
            *ngIf="isUtilityDisplay('Gas')">
            <span accordion-heading class="float-end fs-5 d-flex align-items-center">
                <i class="mdi font-size-24"
                    [ngClass]="!group?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ' : 'mdi mdi-chevron-up accor-plus-icon '"></i>
            </span>

            <div class="row" formGroupName="gas">
                <div class="col-lg-4">
                    <div class="mb-3">
                        <label for="gasValue">Gas Value (Conversion Factor)<span class="required">*</span></label>
                        <input type="text" class="form-control" id="gasValue" formControlName="gasValue"
                            (input)="onGasInput($event)" (blur)="onGasValueBlur($event)">
                        @if((submitted || gasForm.controls['gasValue'].touched) &&
                        gasForm.controls['gasValue']?.errors) {
                        <div class="invalid-feedback">
                            @if(gasForm.controls['gasValue'].errors?.['required']) {
                            <div>{{ utility_gas_Validations.gasValue.required }}</div>
                            }
                            @if(gasForm.controls['gasValue'].errors?.['minlength']) {
                            <div>{{utility_gas_Validations.gasValue.minLengthValidator}}</div>}
                            @if(gasForm.controls['gasValue'].errors?.['maxlength']){
                            <div>{{utility_gas_Validations.gasValue.MaxLengthValidator}}</div>
                            }

                            @if(gasForm.controls['gasValue'].errors?.['pattern']) {
                            <div>{{utility_gas_Validations.gasValue.patternValidation}}</div>}
                        </div>
                        }
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="mb-3">
                        <label for="UnitLPGValue">1 KG/ LPG<span class="required">*</span></label>
                        <input type="text" class="form-control" id="UnitLPGValue" (input)="onGasInput($event)"
                            formControlName="UnitLPGValue">
                        @if((submitted || gasForm.controls['UnitLPGValue'].touched)&&
                        gasForm.controls['UnitLPGValue']?.errors) {
                        <div class="invalid-feedback">
                            @if(gasForm.controls['UnitLPGValue']?.errors?.['required']) {
                            <div>{{ utility_gas_Validations.UnitLPGValue.required }}</div>
                            }
                            @if(gasForm.controls['UnitLPGValue'].errors?.['pattern']) {
                            <div>{{utility_gas_Validations.UnitLPGValue.patternValidation}}</div>}
                        </div>
                        }
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="mb-3">
                        <label for="unitPrice">Unit Price (1 m³/ LPG (In Rs))<span class="required">*</span></label>
                        <input type="text" class="form-control disabled" id="unitPrice" [readonly]="true"
                            formControlName="unitPrice">
                        @if((submitted || gasForm.controls['unitPrice'].touched)&&
                        gasForm.get('unitPrice')?.errors) {
                        <div class="invalid-feedback">
                            @if(gasForm.get('unitPrice')?.errors?.['required']) {
                            <div>{{ utility_gas_Validations.unitPrice.required }}</div>
                            }
                            @if(gasForm.get('unitPrice')?.errors?.['maxValue']) {
                            <div>{{ utility_gas_Validations.unitPrice.maxValue }}</div>
                            }
                            @if(gasForm.controls['unitPrice'].errors?.['pattern']) {
                            <div>{{utility_gas_Validations.UnitLPGValue.patternValidation}}</div>}
                        </div>
                        }
                    </div>
                </div>

            </div>
            <div class="col-lg-6 mb-3">
                <!-- Title and Download Link in a single row -->
                <div class="d-flex align-items-center">
                    <label for="basicpill-declaration-input" class="me-2">Upload Gas Document</label>
                </div>
                <div class="upload-container">
                    <!-- Kendo Upload Component -->
                    <kendo-upload [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" (success)="onSuccess()"
                        (upload)="uploadGasFileEventHandler($event)" (remove)="removeGasFileEventHandler($event)"
                        formControlName="GasFile" id="File" [batch]="false" [multiple]="false"
                        accept=".pdf,.png,.jpg,.jpeg,.xls,.xlsx">
                    </kendo-upload>


                    <!-- Download Button -->
                    <button type="button" *ngIf="getUtilitiesData?.gas&&getUtilitiesData?.gas?.gasFile?.fileUrl"
                        class="btn btn-icon" title="Download"
                        (click)="downloadFile(getUtilitiesData?.gas?.gasFile?.fileUrl,getUtilitiesData?.gas?.gasFile?.fileName)"
                        style="margin-left: 10px;">
                        <i class="fa fa-download"></i>
                    </button>
                </div>


            </div>
        </accordion-group>


      
        <!-- ========== WATER ========== -->
        <accordion-group heading="Water" *ngIf="isUtilityDisplay('Water')"
            [isOpen]="false" class="accordion-item mb-3 panel-open" #group>
            <span accordion-heading class="float-end fs-5 d-flex align-items-center">
                <i class="mdi font-size-24"
                    [ngClass]="!group?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ' : 'mdi mdi-chevron-up accor-plus-icon '"></i>
            </span>


            <!-- Add Range button -->
            <div class="text-end mt-2" *ngIf="isSqftBilling" >
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="addRange('water')">+ Add
                    Sqft
                    Range</button>
            </div>
            <hr>
            <div formArrayName="water">
                <div *ngFor="let range of waterRangeArray.controls; let r = index" [formGroupName]="r"
                    class="range-card">
                    <div class="row mt-3">
                        <div class="col">
                            <label>Square Feet Minimum value <span class="required">*</span></label>
                            <input class="form-control" formControlName="sqftMin" />
                            @if ((submitted || range.get('sqftMin')?.touched) && range.get('sqftMin')?.errors) {
                            <div class="invalid-feedback d-block">
                                @if(range.get('sqftMin')?.errors?.['required']) { <div>Square Feet Min is required</div>
                                }
                                @if(range.get('sqftMin')?.errors?.['pattern']) { <div>Invalid number</div> }
                            </div>
                            }
                            @if((submitted || range.touched) && range.errors?.['sqftMinNotEqualPrevMax']) {
                            <div class="text-danger">The Min value must exactly match previous range Max.</div>
                            }
                        </div>

                        <div class="col d-flex align-items-end gap-4 mb-3">
                            <div class="w-100">
                                <label>Square Feet Maximum value <span class="required">*</span></label>
                                <input class="form-control" formControlName="sqftMax" />
                                @if ((submitted || range.get('sqftMax')?.touched) && range.get('sqftMax')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(range.get('sqftMax')?.errors?.['required']) { <div> Square Feet Max is required
                                    </div> }
                                    @if(range.get('sqftMax')?.errors?.['pattern']) { <div>Invalid number</div> }
                                </div>
                                }
                                @if((submitted || range.touched) && range.errors?.['minGreaterOrEqualMax']) {
                                <div class="text-danger">Square Feet Max must be greater than Min</div>
                                }
                            </div>
                            <i (click)="removeRange(waterRangeArray, r)" *ngIf="waterRangeArray.length > 1"
                                class="fas fa-trash-alt cursor-pointer text-danger" title="Delete Range">
                            </i>
                        </div>


                    </div>

                    <!-- Slabs -->
                    <div formArrayName="slabs" class="mt-3">
                        <div *ngFor="let slab of slabsOf(range).controls; let i=index" [formGroupName]="i"
                            class="row slab-row">
                            <div class="col mt-3">
                                <label>Supplier Name <span class="required">*</span></label>
                                <ng-select [items]="waterTypeItems" bindLabel="name" bindValue="id"
                                    formControlName="slabName"  [clearable]="isClearable(slab.get('slabName')?.value)"></ng-select>
                                @if((submitted || slab.get('slabName')?.touched) && slab.get('slabName')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(slab.get('slabName')?.errors?.['required']) { <div>Supplier is required
                                    </div> }
                                </div>
                                }
                            </div>

                            <div class="col mt-3">
                                <label>Min <span class="required">*</span></label>
                                <input class="form-control" formControlName="min" />
                                @if((submitted || slab.get('min')?.touched) && slab.get('min')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(slab.get('min')?.errors?.['required']) { <div>{{
                                        utility_water_Validations.MinValue.required }}</div> }
                                    @if(slab.get('min')?.errors?.['pattern']) { <div>
                                        {{utility_water_Validations.MinValue.patternValidation}}</div>}
                                    @if(slab.get('min')?.errors?.['slabNotContinuous']) {
                                    <div>Min must be exactly equal to previous slab's Max for the same Supplier.
                                    </div>
                                    }
                                </div>
                                }
                            </div>

                            <div class="col mt-3">
                                <label>Max <span class="required">*</span></label>
                                <input class="form-control" formControlName="max" />
                                @if((submitted || slab.get('max')?.touched) && slab.get('max')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(slab.get('max')?.errors?.['required']) { <div>{{
                                        utility_water_Validations.MaxValue.required }}</div> }
                                    @if(slab.get('max')?.errors?.['pattern']) { <div>
                                        {{utility_water_Validations.MaxValue.patternValidation}}</div> }
                                </div>
                                }
                                @if((submitted || slab.get('min')?.dirty || slab.get('max')?.dirty) &&
                                slab.get('min')?.value !== '' && slab.get('max')?.value !== '' &&
                                slab.errors?.['minGreaterOrEqualMax']) {
                                <div class="text-danger">Max must be greater than Min</div>
                                }
                            </div>

                            <div class="col d-flex align-items-end gap-4 mt-3 mb-3">
                                <div class="w-100">
                                    <label>Slab Per Unit Price <span class="required">*</span></label>
                                    <input class="form-control" formControlName="unitPrice" />
                                    @if((submitted || slab.get('unitPrice')?.touched) && slab.get('unitPrice')?.errors)
                                    {
                                    <div class="invalid-feedback d-block">
                                        @if(slab.get('unitPrice')?.errors?.['required']) { <div>{{
                                            utility_water_Validations.slabPerUnit.required }}
                                        </div> }
                                        @if(slab.get('unitPrice')?.errors?.['maxValue']) { <div>{{
                                            utility_water_Validations.slabPerUnit.maxValue }}
                                        </div> }
                                        @if(slab.get('unitPrice')?.errors?.['pattern']) { <div>
                                            {{utility_electricity_Validations.UnitPrice.patternValidation}}
                                        </div> }
                                    </div>
                                    }
                                </div>
                                <i (click)="removeSlab(range, i)" *ngIf="slabsOf(range).length > 1"
                                    class="fas fa-trash-alt cursor-pointer text-danger" title="Delete Slab">
                                </i>
                            </div>

                            <!--  <div class="col-1 d-flex align-items-start mt-4">
                                <label> </label>
                                <i (click)="removeSlab(range, i)" *ngIf="slabsOf(range).length > 1" style="float: right"
                                    class="fas fa-trash-alt  cursor-pointer text-danger">
                                </i>
                               
                            </div> -->
                        </div>
                        <hr>
                        <div class="text-end mt-4">
                            <button class="btn btn-primary btn-sm" type="button" (click)="addSlab(range)">+ Add
                                Row</button>
                        </div>
                    </div>
                </div>


            </div>
            <div class="col-lg-6 mb-3">

                <div class="d-flex align-items-center">
                    <label for="basicpill-declaration-input">Upload Water Document</label>
                </div>

                <div class="upload-container">

                    <kendo-upload [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" (success)="onSuccess()"
                        (upload)="uploadWaterFileEventHandler($event)" (remove)="removeWaterFileEventHandler($event)"
                        formControlName="WaterFile" id="WaterFile" [batch]="false" [multiple]="false"
                        accept=".pdf,.png,.jpg,.jpeg,.xls,.xlsx">
                    </kendo-upload>



                    <button type="button"
                        *ngIf="getUtilitiesData?.water&&getUtilitiesData?.water[0]?.waterFile?.fileUrl"
                        class="btn btn-icon" title="Download"
                        (click)="downloadFile(getUtilitiesData?.water[0]?.waterFile?.fileUrl,getUtilitiesData?.water[0]?.waterFile?.fileName)"
                        style="margin-left: 10px;">
                        <i class="fa fa-download"></i>
                    </button>
                </div>
            </div>



        </accordion-group>



        <!-- ========== ELECTRICITY ========== -->
        <accordion-group heading="Electricity" *ngIf="isUtilityDisplay('Electricity')"
            [isOpen]="false" class="accordion-item mb-3 panel-open" #group>
            <span accordion-heading class="float-end fs-5 d-flex align-items-center">
                <i class="mdi font-size-24"
                    [ngClass]="!group?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ' : 'mdi mdi-chevron-up accor-plus-icon '"></i>
            </span>




            <div class="text-end mt-2" *ngIf="isSqftBilling">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="addRange('electricity')">+ Add
                    Sqft
                    Range</button>
            </div>
            <hr>
            <div formArrayName="electricity">
                <div *ngFor="let range of electricRangeArray.controls; let e = index" [formGroupName]="e"
                    class="range-card">

                    <div class="row  mt-3">
                        <div class="col ">
                            <label>Square Feet Minimum value <span class="required">*</span></label>
                            <input class="form-control" formControlName="sqftMin" />

                            @if((submitted || range.get('sqftMin')?.touched) && range.get('sqftMin')?.errors) {
                            <div class="invalid-feedback d-block">
                                @if(range.get('sqftMin')?.errors?.['required']) { <div>Square Feet Min is required</div>
                                }
                                @if(range.get('sqftMin')?.errors?.['pattern']) { <div>Invalid number</div> }
                            </div>
                            }

                            @if((submitted || range.touched) && range.errors?.['sqftMinNotEqualPrevMax']) {
                            <div class="text-danger">The Min value must exactly match previous range Max.</div>
                            }
                        </div>

                        <div class="col d-flex align-items-end gap-4">
                            <div class="w-100">
                                <label>Square Feet Maximum value <span class="required">*</span></label>
                                <input class="form-control" formControlName="sqftMax" />

                                @if((submitted || range.get('sqftMax')?.touched) && range.get('sqftMax')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(range.get('sqftMax')?.errors?.['required']) { <div>Square Feet Max is required
                                    </div> }
                                    @if(range.get('sqftMax')?.errors?.['pattern']) { <div>Invalid number</div> }
                                </div>
                                }

                                @if((submitted || range.touched) && range.errors?.['minGreaterOrEqualMax']) {
                                <div class="text-danger">Square Feet Max must be greater than Min</div>
                                }

                            </div>
                            <i (click)="removeRange(electricRangeArray, e)" *ngIf="electricRangeArray.length > 1"
                                class="fas fa-trash-alt  cursor-pointer text-danger">
                            </i>
                        </div>

                        <!--  <div class="col-1">
                            <label> </label>
                            <i (click)="removeRange(electricRangeArray, e)" *ngIf="electricRangeArray.length > 1"
                                style="float: right" class="fas fa-trash-alt  cursor-pointer text-danger">
                            </i>
                           
                        </div> -->
                    </div>
                    <hr>


                    <div formArrayName="slabs" class="mt-3">
                        <div *ngFor="let slab of slabsOf(range).controls; let i=index" [formGroupName]="i"
                            class="row slab-row">

                            <!-- Supplier -->
                            <div class="col mt-3">
                                <label>Supplier Name <span class="required">*</span></label>
                                <ng-select [items]="electricityTypeItems" bindLabel="name" bindValue="id"
                                    formControlName="slabName"  [clearable]="isClearable(slab.get('slabName')?.value)"></ng-select>

                                @if((submitted || slab.get('slabName')?.touched) && slab.get('slabName')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(slab.get('slabName')?.errors?.['required']) { <div>{{
                                        utility_electricity_Validations.slabName.required }}</div> }
                                </div>
                                }
                            </div>


                            <div class="col mt-3">
                                <label>Min <span class="required">*</span></label>
                                <input class="form-control" formControlName="min" />
                                @if((submitted || slab.get('min')?.touched) && slab.get('min')?.errors) {
                                <div class="invalid-feedback d-block">

                                    @if(slab.get('min')?.errors?.['required']) {
                                    <div>{{ utility_electricity_Validations.minKwh.required }}</div>
                                    }

                                    @if(slab.get('min')?.errors?.['pattern']) {
                                    <div>{{ utility_electricity_Validations.minKwh.patternValidation }}</div>
                                    }

                                    @if(slab.get('min')?.errors?.['slabNotContinuous']) {
                                    <div>Min must be exactly equal to previous slab's Max for the same Supplier.
                                    </div>
                                    }
                                    <!-- @if((submitted || slab.touched) && slab.errors?.['slabNotContinuous']) {
                                    <div class="text-danger">
                                        Min must be exactly equal to previous slab's Max for the same Supplier.
                                    </div>
                                    } -->
                                </div>
                                }


                            </div>


                            <div class="col mt-3">
                                <label>Max <span class="required">*</span></label>
                                <input class="form-control" formControlName="max" />

                                @if((submitted || slab.get('max')?.touched) && slab.get('max')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(slab.get('max')?.errors?.['required']) { <div>{{
                                        utility_electricity_Validations.maxKwh.required }}</div> }
                                    @if(slab.get('max')?.errors?.['pattern']) { <div>
                                        {{utility_electricity_Validations.maxKwh.patternValidation}}</div> }
                                </div>
                                }

                                @if((submitted || slab.get('min')?.dirty || slab.get('max')?.dirty) &&
                                slab.get('min')?.value !== '' && slab.get('max')?.value !== '' &&
                                slab.errors?.['minGreaterOrEqualMax']) {
                                <div class="text-danger">Max must be greater than Min</div>
                                }
                            </div>


                            <div class="col d-flex align-items-end gap-4 mt-3 mb-3">
                                <div class="w-100">
                                    <label>Slab Per Unit Price <span class="required">*</span></label>
                                    <input class="form-control" formControlName="unitPrice" />

                                    @if((submitted || slab.get('unitPrice')?.touched) && slab.get('unitPrice')?.errors)
                                    {
                                    <div class="invalid-feedback d-block">
                                        @if(slab.get('unitPrice')?.errors?.['required']) { <div>{{
                                            utility_electricity_Validations.UnitPrice.required }}
                                        </div> }
                                        @if(slab.get('unitPrice')?.errors?.['maxValue']) { <div>{{
                                            utility_electricity_Validations.UnitPrice.maxValue }}
                                        </div> }
                                        @if(slab.get('unitPrice')?.errors?.['pattern']) { <div>
                                            {{utility_electricity_Validations.UnitPrice.patternValidation}}</div> }
                                    </div>
                                    }
                                </div>
                                <i (click)="removeSlab(range, i)" *ngIf="slabsOf(range).length > 1"
                                    class="fas fa-trash-alt  cursor-pointer text-danger">
                                </i>
                            </div>



                        </div>
                        <hr>

                        <div class="text-end mt-4">
                            <button class="btn btn-primary btn-sm" type="button" (click)="addSlab(range)">+ Add
                                Row</button>
                        </div>
                    </div>

                </div>
            </div>


            <div class="col-lg-6 mb-3">
                <label for="basicpill-declaration-input">Upload Electricity Document</label>

                <div class="upload-container">

                    <kendo-upload [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" (success)="onSuccess()"
                        (upload)="uploadEleFileEventHandler($event)" (remove)="removeEleFileEventHandler($event)"
                        formControlName="ElectricityFile" id="ElectricityFile" [batch]="false" [multiple]="false"
                        accept=".pdf,.png,.jpg,.jpeg,.xls,.xlsx">
                    </kendo-upload>


                    <button type="button"
                        *ngIf="getUtilitiesData?.electricity&&getUtilitiesData?.electricity[0]?.electricityFile?.fileUrl"
                        class="btn btn-icon" title="Download"
                        (click)="downloadFile(getUtilitiesData?.electricity[0]?.electricityFile?.fileUrl,getUtilitiesData?.electricity[0]?.electricityFile?.fileName)"
                        style="margin-left: 10px;">
                        <i class="fa fa-download"></i>
                    </button>
                </div>
            </div>
        </accordion-group>




        <!-- ========== TRISOURCE ========== -->
        <accordion-group heading="TriSource" *ngIf="isUtilityDisplay('TriSource')"
            [isOpen]="false" class="accordion-item mb-3 panel-open" #group>
            <span accordion-heading class="float-end fs-5 d-flex align-items-center">
                <i class="mdi font-size-24"
                    [ngClass]="!group?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ' : 'mdi mdi-chevron-up accor-plus-icon '"></i>
            </span>

            <!--   <button class="btn btn-danger float-end" (click)="addRange('trisource')">Add New Sqft Range</button> -->
            <div class="text-end mt-2" *ngIf="isSqftBilling">
                <button type="button" class="btn btn-sm btn-outline-primary" (click)="addRange('trisource')">+ Add
                    Sqft
                    Range</button>
            </div>

            <hr>
            <div formArrayName="trisource">
                <div *ngFor="let range of triRangeArray.controls; let r = index" [formGroupName]="r" class="range-card">

                    <div class="row  mt-3">
                        <div class="col">
                            <label>Square Feet Minimum value <span class="required">*</span></label>
                            <input class="form-control" formControlName="sqftMin" />

                            @if((submitted || range.get('sqftMin')?.touched) && range.get('sqftMin')?.errors) {
                            <div class="invalid-feedback d-block">
                                @if(range.get('sqftMin')?.errors?.['required']) { <div>Square Feet Min is required</div>
                                }
                                @if(range.get('sqftMin')?.errors?.['pattern']) { <div>Invalid number</div> }
                            </div>
                            }

                            @if(range.errors?.['sqftMinNotEqualPrevMax']) {
                            <div class="text-danger">The Min must match previous range Max.</div>
                            }
                        </div>

                        <div class="col d-flex align-items-end gap-4">
                            <div class="w-100">
                                <label>Square Feet Maximum value <span class="required">*</span></label>
                                <input class="form-control" formControlName="sqftMax" />

                                @if((submitted || range.get('sqftMax')?.touched) && range.get('sqftMax')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(range.get('sqftMax')?.errors?.['required']) { <div>Square Feet Max is required
                                    </div> }
                                    @if(range.get('sqftMax')?.errors?.['pattern']) { <div>Invalid number</div> }
                                </div>
                                }

                                @if(range.errors?.['minGreaterOrEqualMax']) {
                                <div class="text-danger">Square Feet Max must be greater than Min</div>
                                }
                            </div>
                            <i (click)="removeRange(triRangeArray, r)" *ngIf="triRangeArray.length > 1"
                                class="fas fa-trash-alt  cursor-pointer text-danger">
                            </i>
                        </div>

                        <!--  <div class="col-1">
                            <label> </label>
                            <i (click)="removeRange(triRangeArray, r)" *ngIf="triRangeArray.length > 1"
                                style="float: right" class="fas fa-trash-alt  cursor-pointer text-danger">
                            </i>
                           
                        </div> -->
                    </div>

                    <!-- Slabs -->
                    <div formArrayName="slabs" class="mt-3">
                        <div *ngFor="let slab of slabsOf(range).controls; let i=index" [formGroupName]="i"
                            class="row slab-row">
                            <div class="col mt-3">
                                <label>Supplier Name <span class="required">*</span></label>
                                <ng-select [items]="triSourceItems" bindLabel="name" bindValue="id"
                                    formControlName="slabName" [clearable]="isClearable(slab.get('slabName')?.value)"></ng-select>

                                @if(slab.get('slabName')?.touched && slab.get('slabName')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(slab.get('slabName')?.errors?.['required']) { <div>{{
                                        utility_electricity_Validations.slabName.required }}</div> }
                                </div>
                                }
                            </div>

                            <div class="col mt-3">
                                <label>Min<span class="required">*</span></label>
                                <input class="form-control" formControlName="min" />

                                @if(slab.get('min')?.touched && slab.get('min')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(slab.get('min')?.errors?.['required']) { <div>{{
                                        utility_electricity_Validations.minKwh.required }}</div> }
                                    @if(slab.get('min')?.errors?.['pattern']) { <div>
                                        {{utility_electricity_Validations.minKwh.patternValidation}}</div> }
                                    @if(slab.get('min')?.errors?.['slabNotContinuous']) {
                                    <div>Min must be EXACTLY equal to previous slab's Max for the same Supplier.</div>
                                    }
                                </div>
                                }
                            </div>

                            <div class="col mt-3">
                                <label>Max <span class="required">*</span></label>
                                <input class="form-control" formControlName="max" />

                                @if(slab.get('max')?.touched && slab.get('max')?.errors) {
                                <div class="invalid-feedback d-block">
                                    @if(slab.get('max')?.errors?.['required']) { <div>{{
                                        utility_electricity_Validations.maxKwh.required }}</div> }
                                    @if(slab.get('max')?.errors?.['pattern']) { <div>
                                        {{utility_electricity_Validations.maxKwh.patternValidation}}</div> }
                                </div>
                                }

                                @if((submitted || slab.get('min')?.dirty || slab.get('max')?.dirty) &&
                                slab.get('min')?.value !== '' && slab.get('max')?.value !== '' &&
                                slab.errors?.['minGreaterOrEqualMax']) {
                                <div class="text-danger">Max must be greater than Min</div>
                                }
                            </div>

                            <div class="col d-flex align-items-end gap-4 mt-3 mb-3">
                                <div class="w-100">
                                    <label>Slab Per Unit Price<span class="required">*</span></label>
                                    <input class="form-control" formControlName="unitPrice" />

                                    @if(slab.get('unitPrice')?.touched && slab.get('unitPrice')?.errors) {
                                    <div class="invalid-feedback d-block">
                                        @if(slab.get('unitPrice')?.errors?.['required']) { <div>{{
                                            utility_electricity_Validations.UnitPrice.required }}
                                        </div> }
                                        @if(slab.get('unitPrice')?.errors?.['maxValue']) { <div>{{
                                            utility_electricity_Validations.UnitPrice.maxValue }}
                                        </div> }
                                        @if(slab.get('unitPrice')?.errors?.['pattern']) { <div>
                                            {{utility_electricity_Validations.UnitPrice.patternValidation}}
                                        </div> }
                                    </div>
                                    }
                                </div>
                                <i (click)="removeSlab(range, i)" *ngIf="slabsOf(range).length > 1"
                                    class="fas fa-trash-alt  cursor-pointer text-danger">
                                </i>
                            </div>

                            <!--  <div class="col-1 d-flex align-items-start">
                                <label> </label>
                                <i (click)="removeSlab(range, i)" *ngIf="slabsOf(range).length > 1" style="float: right"
                                    class="fas fa-trash-alt  cursor-pointer text-danger">
                                </i>
                               
                            </div> -->
                        </div>
                        <hr>
                        <div class="text-end mt-4">
                            <button class="btn btn-primary btn-sm" type="button" (click)="addSlab(range)">+ Add
                                Row</button>
                        </div>
                    </div>

                </div>
            </div>


            <div class="col-lg-6 mb-3">
                <label for="basicpill-declaration-input">Upload TriSource Document</label>

                <div class="upload-container">

                    <kendo-upload [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" (success)="onSuccess()"
                        (upload)="uploadTriSourceFileEventHandler($event)"
                        (remove)="removeTriSourceFileEventHandler($event)" formControlName="triSourceFile"
                        id="triSourceFile" [batch]="false" [multiple]="false" accept=".pdf,.png,.jpg,.jpeg,.xls,.xlsx">
                    </kendo-upload>


                    <button type="button"
                        *ngIf="getUtilitiesData?.triSource&&getUtilitiesData?.triSource[0]?.triSourceFile?.fileUrl"
                        class="btn btn-icon" title="Download"
                        (click)="downloadFile(getUtilitiesData?.triSource[0]?.triSourceFile?.fileUrl,getUtilitiesData?.triSource[0]?.triSourceFile?.fileName)"
                        style="margin-left: 10px;">
                        <i class="fa fa-download"></i>
                    </button>
                </div>
            </div>
        </accordion-group>

        <!-- ========== EV ========== -->
        <accordion-group heading="EV" *ngIf="isUtilityDisplay('EV')"
            [isOpen]="false" class="accordion-item mb-3 panel-open" #group>
            <span accordion-heading class="float-end fs-5 d-flex align-items-center">
                <i class="mdi font-size-24"
                    [ngClass]="!group?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ' : 'mdi mdi-chevron-up accor-plus-icon '"></i>
            </span>

            <div formArrayName="EV">
                <div *ngFor="let ev of evArray.controls; let i = index" [formGroupName]="i" class="row slab-row">
                    <div class="col mt-3">
                        <label>Supplier Name <span class="required">*</span></label>
                        <ng-select [items]="evTypeItems" bindLabel="name" bindValue="id" formControlName="slabName"
                            [clearable]="isClearable(ev.get('slabName')?.value)"></ng-select>

                        @if((submitted || ev.get('slabName')?.touched) && ev.get('slabName')?.errors) {
                        <div class="invalid-feedback d-block">
                            @if(ev.get('slabName')?.errors?.['required']) {
                            <div>{{ utility_electricity_Validations.slabName.required }}</div>
                            }
                        </div>
                        }
                    </div>

                    <div class="col d-flex align-items-end gap-4 mt-3 mb-3">
                        <div class="w-100">
                            <label>Slab Per Unit Price <span class="required">*</span></label>
                            <input class="form-control" formControlName="unitPrice" />

                            @if((submitted || ev.get('unitPrice')?.touched) && ev.get('unitPrice')?.errors) {
                            <div class="invalid-feedback d-block">
                                @if(ev.get('unitPrice')?.errors?.['required']) {
                                <div>{{ utility_electricity_Validations.UnitPrice.required }}</div>
                                }
                                @if(ev.get('unitPrice')?.errors?.['maxValue']) {
                                <div>{{ utility_electricity_Validations.UnitPrice.maxValue }}</div>
                                }
                                @if(ev.get('unitPrice')?.errors?.['pattern']) {
                                <div>{{ utility_electricity_Validations.UnitPrice.patternValidation }}</div>
                                }
                            </div>
                            }
                        </div>
                        <i (click)="removeEV(i)" *ngIf="evArray.length > 1"
                            class="fas fa-trash-alt cursor-pointer text-danger" title="Delete EV Slab">
                        </i>
                    </div>
                </div>
            </div>

            <hr>
            <div class="text-end mt-4">
                <button class="btn btn-primary btn-sm" type="button" (click)="addEV()">+ Add Row</button>
            </div>

            <div class="col-lg-6 mb-3">
                <label for="basicpill-declaration-input">Upload EV Document</label>

                <div class="upload-container">
                    <kendo-upload [saveUrl]="uploadSaveUrl" [removeUrl]="uploadRemoveUrl" (success)="onSuccess()"
                        (upload)="uploadEVFileEventHandler($event)" (remove)="removeEVFileEventHandler($event)"
                        formControlName="EVFile" id="EVFile" [batch]="false" [multiple]="false"
                        accept=".pdf,.png,.jpg,.jpeg,.xls,.xlsx">
                    </kendo-upload>

                    <button type="button"
                        *ngIf="evFileData?.fileUrl"
                        class="btn btn-icon" title="Download"
                        (click)="downloadFile(evFileData?.fileUrl, evFileData?.fileName)"
                        style="margin-left: 10px;">
                        <i class="fa fa-download"></i>
                    </button>
                </div>
            </div>
        </accordion-group>

    </accordion>
    <div class="d-flex justify-content-end" *ngIf="hasVisibleUtilityConfig()">
        <button type="submit" class="btn btn-primary" (click)="submit()">{{ getUtilitiesData ? 'Update' : 'Save' }}

        </button>
    </div>
    <!--  <button class="btn btn-success mt-3" (click)="submit()">Submit</button> -->



</form>
